export const companyKeys = {
  all: ['companies'] as const,
  capabilities: (companyId: string) => [...companyKeys.all, 'capabilities', companyId] as const,
};
